/**
 * A group member's display name (namat-mobile#73: the web member list showed
 * "undefined undefined"). Pure, no Firebase imports.
 */
import { localizedName } from './groupPosts';

export interface MemberNameFields {
  firstNameAr?: string | null;
  lastNameAr?: string | null;
  firstNameEn?: string | null;
  lastNameEn?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  name?: string | null;
}

/** The users-doc fields memberDisplayName reads, copied off a raw doc. */
export function pickMemberNameFields(data: Record<string, unknown> | null | undefined): MemberNameFields {
  const str = (v: unknown) => (typeof v === 'string' ? v : undefined);
  const d = data || {};
  return {
    firstNameAr: str(d.firstNameAr),
    lastNameAr: str(d.lastNameAr),
    firstNameEn: str(d.firstNameEn),
    lastNameEn: str(d.lastNameEn),
    firstName: str(d.firstName),
    lastName: str(d.lastName),
    displayName: str(d.displayName),
    name: str(d.name),
  };
}

/**
 * Arabic name in Arabic, English otherwise (each falling back to the other),
 * then legacy firstName/lastName, displayName, name, then `fallback`.
 */
export function memberDisplayName(person: MemberNameFields | null | undefined, language: string, fallback = ''): string {
  const legacy = `${person?.firstName ?? ''} ${person?.lastName ?? ''}`.replace(/\s+/g, ' ').trim();
  return (
    localizedName(person, language) ||
    legacy ||
    (person?.displayName ?? '').trim() ||
    (person?.name ?? '').trim() ||
    fallback.trim()
  );
}
